import { render, staticRenderFns } from "./PlaceListView.vue?vue&type=template&id=65775b06&scoped=true"
import script from "./PlaceListView.vue?vue&type=script&lang=js"
export * from "./PlaceListView.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/college/PlaceListView.css?vue&type=style&index=0&id=65775b06&prod&scoped=true&lang=css&external"
import style1 from "./PlaceListView.vue?vue&type=style&index=1&id=65775b06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65775b06",
  null
  
)

export default component.exports